/**
 * HerSkin — Web Interface for Hermes Agent
 * @author Jevin With GPT
 * @since 2026-08
 */

import "@herskin/ui/styles.css";
import "@herskin/markdown/styles.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppErrorBoundary } from "./AppErrorBoundary";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
